export enum EntityType {
  Turnover = 1,
  Bid,
  Ticket,
  WorkflowStep,
  Company,
}
